import { Button } from "@repo/ui/components/ui/button";
import type { OrderSetEditor } from "../hooks/use-order-set-draft";
import { OrderSetFooterStatus } from "./order-set-footer-status";

export function OrderSetDraftFeedback({ draft }: { draft: OrderSetEditor }) {
  return (
    <section aria-label="Order set changes" className="flex items-center justify-between gap-2">
      <div className="min-w-0 flex-1">
        {(draft.saving || draft.dirty) && (
          <OrderSetFooterStatus
            label={draft.saving ? "Saving" : "Draft"}
            tone={draft.saving ? "progress" : "pending"}
            message={draft.saving ? undefined : "Save to activate"}
          />
        )}
      </div>
      <div className="flex shrink-0 gap-2">
        <Button type="button" size="sm" variant="ghost" disabled={!draft.dirty || draft.saving} onClick={draft.discard}>
          Discard
        </Button>
        <Button type="button" size="sm" disabled={!draft.dirty || !draft.canSave || draft.saving} onClick={draft.save}>
          Save
        </Button>
      </div>
    </section>
  );
}
